import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { SERVER_URL } from './apiConstants';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const forgetpassword = 'forgot-password';
export const forgetPassword = createAsyncThunk('api/forgetpassword', async (data) => {
  const body = {
    email: data.email,
  };
  return axios
    .post(`${SERVER_URL}/${forgetpassword}`, body, { headers })
    .then((response) => {
      if (response.data && response.data.success) {
        return response.data;
      }
      // 200 with message only (e.g. legacy or "email not found" response) = success for forgot-password
      const apiMessage = response.data?.message || response.data?.data?.message;
      if (response.status === 200 && apiMessage) {
        return { success: true, data: { message: apiMessage } };
      }
      return Promise.reject(new Error(apiMessage || 'Failed to send reset email'));
    })
    .catch((error) => {
      const apiError = error.response?.data;
      const message =
        apiError?.message ||
        apiError?.data?.message ||
        error?.message ||
        'Failed to send reset email';
      return Promise.reject(new Error(message));
    });
});

const forgetPasswordSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    forgetPasswordData: {},
    error: '',
  },
  extraReducers: {
    [forgetPassword.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [forgetPassword.fulfilled]: (state, action) => {
      state.loading = false;
      state.forgetPasswordData = action.payload;
      if (action.payload && action.payload.success) {
        const message = action.payload.data?.message || 'Reset Password mail sent to your Email';
        toast.success(message);
      }
    },
    [forgetPassword.rejected]: (state, action) => {
      state.loading = false;
      let errorMessage =
        action.error?.message ||
        action.payload?.message ||
        action.payload?.data?.message ||
        'Failed to send reset email';
      if (typeof errorMessage !== 'string') {
        errorMessage =
          errorMessage?.message || errorMessage?.data?.message || 'Failed to send reset email';
      }
      state.error = errorMessage;
      toast.error(errorMessage);
    },
  },
});

export default forgetPasswordSlice.reducer;
